import { contractorApi } from '@/lib/api'

export function unlinkPaymentMethod(id: string) {
  return contractorApi.delete<void>(`/v1/payment-methods/${id}`)
}
